import * as moment from 'moment';
import { DictionaryEntry } from '../../../dictionary.interface';
import { FilterComponent } from '../filter/filter.component';
import { FilterOutput } from '../../../interfaces/filter-outpt.interface';
import { FilterSet } from '../../../interfaces/filter-set.interface';
import { FiltersService } from '../../../services/filters/filters.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FilterQueryValue } from '../../../interfaces/filter-query-value.inteface';
import { FilterInput } from '../../../interfaces/filter-input.interface';
import { FiltersConfig } from '../../../interfaces/filters-config.interface';
import { FilterOutputWrapper } from '../../../interfaces/filter-outpt-wrapper.interface';

export interface FilterSelectionData extends FiltersConfig {
  dataSetName: string;
  displayCancelButton: boolean;
}

@Component({
  selector: 'sellions-layout-renderer-filter-selection',
  templateUrl: './filter-selection.component.html',
})
export class FilterSelectionComponent implements OnInit {
  @ViewChildren(FilterComponent) filterFields: QueryList<FilterComponent>;
  public displayCancelButton = false;
  public appliedValuesMap: {
    [key: string]: any;
  } = {};
  selectedSort: string;
  selectedSortDirection: 'ASC' | 'DESC';

  constructor(
    private filtersService: FiltersService,
    public dialogRef: MatDialogRef<FilterSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterSelectionData,
  ) {}

  ngOnInit() {
    this.filtersService
      .getFilters(this.data.dataSetName)
      .then((filterSet: FilterSet) => {
        if (filterSet) {
          this.data.filters.forEach((filter: FilterInput) => (this.appliedValuesMap[filter.column] = this.getValue(filter, filterSet.filters)));
          if(filterSet.sort && filterSet.sort.column) {
            this.selectedSort = filterSet.sort.column;
            this.selectedSortDirection = filterSet.sort.direction;
          } else if(filterSet.filterConfig.defaultSort) {
            this.selectedSort = filterSet.filterConfig.defaultSort.column;
            this.selectedSortDirection = filterSet.filterConfig.defaultSort.direction;
          } else if(this.data.defaultSort) {
            this.selectedSort = this.data.defaultSort.column;
            this.selectedSortDirection = this.data.defaultSort.direction;
          }
        }

        this.displayCancelButton = this.data.displayCancelButton;
      })
      .catch((error) => console.error(error));
  }

  private getValue(filter: FilterInput, appliedFilters: FilterOutput[]): any {
    const value = appliedFilters && appliedFilters.filter((f: FilterOutput) => f.column === filter.column).map((f) => f.value);
    if (filter.inputType === 'multi-select') {
      return value.length ? value : [''];
    } else {
      return value.length ? value[0] : '';
    }
  }

  public applyFilters() {
    this.dialogRef.close(this.getFilters());
  }

  private getFilters(): FilterOutputWrapper {
    const filters: FilterOutput[] = [];

    this.filterFields.forEach((field) => {
      if (field.selected) {
        if (Array.isArray(field.selected)) {
          filters.push(...this.getFiltersForMultiSelectField(field));
        } else {
          filters.push(this.getFilter(field, field.selected));
        }
      }
    });

    return {
      filters,
      sort: {
        column: this.selectedSort,
        direction: this.selectedSortDirection
      }
    };
  }

  private getFiltersForMultiSelectField(field: FilterComponent): FilterOutput[] {
    const filters: FilterOutput[] = [];

    const selectedValues = field.selected as Array<any>;

    if (selectedValues.length !== 1) {
      selectedValues.forEach((value) => {
        if (value) {
          const filter = this.getFilter(field, value);
          filter.queryValue.or = true;
          filters.push(filter);
        }
      });
    } else if (selectedValues[0]) {
      filters.push(this.getFilter(field, selectedValues[0]));
    }

    return filters;
  }

  private getFilter(field: FilterComponent, value: any): FilterOutput {
    const filter: FilterOutput = {
      column: field.filter.column,
      value,
      type: field.filter.type,
      queryValue: this.getFilterQueryValue(field, value),
    };

    return filter;
  }

  private getFilterQueryValue(field: FilterComponent, value: any): FilterQueryValue {
    const queryValue: FilterQueryValue = {
      column: field.filter.queryValue && field.filter.queryValue.column,
      type: field.filter.queryValue ? field.filter.queryValue.type : 'EQUALS',
      value: this.getFilterValue(value),
    };

    if (field.filter.queryValue && field.filter.queryValue.type === 'NESTED') {
      queryValue.nestedColumn = field.filter.queryValue.nestedColumn;
      queryValue.nestedType = field.filter.queryValue.nestedType;
      if (value[field.filter.queryValue.nestedColumn]) {
        queryValue.value = this.getFilterValue(value[field.filter.queryValue.nestedColumn]);
      }
    }

    return queryValue;
  }

  private getFilterValue(value: any | Array<string | DictionaryEntry>): string {
    if (value instanceof Date)
      return (
        moment(value).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss') +
        'Z' +
        ' AND ' +
        moment(value).endOf('day').format('YYYY-MM-DD[T]HH:mm:ss') +
        'Z'
      );
    else if (value instanceof moment) return (value as moment.Moment).format('YYYY-MM-DD[T]HH:mm:ss') + 'Z';
    else return typeof value === 'string' ? value : value.toString();
  }

  public close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/filters/filter-selection/filter-selection.component.ts